import {
  InvalidValueInCollisionConfig,
  MissingAdditionalTextCollisionConfig,
  MissingTextPlacementCollisionConfig,
} from './consts';
import { com } from '../../../generated/proto-generated';

export const verifyResolvingNameConflictsConfig = (
  resolvingNameConflictsForType,
  memberType,
) => {
  const { additionalText, textPlacement } = resolvingNameConflictsForType;
  if (additionalText && !textPlacement) {
    throw new MissingTextPlacementCollisionConfig(memberType);
  } else if (!additionalText && textPlacement) {
    throw new MissingAdditionalTextCollisionConfig(memberType);
  } else if (
    textPlacement &&
    ![
      com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.TextPlacement
        .NO_PLACEMENT,
      com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.TextPlacement
        .SUFFIX,
      com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.TextPlacement
        .PREFIX,
    ].includes(textPlacement)
  ) {
    throw new InvalidValueInCollisionConfig(memberType, textPlacement);
  }
};
